var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31802 20.5355C5.63604 22 7.75736 22 12 22C16.2426 22 18.364 22 19.682 20.5355C21 19.0711 21 16.714 21 12C21 7.28595 21 4.92893 19.682 3.46447C18.364 2 16.2426 2 12 2C7.75736 2 5.63604 2 4.31802 3.46447C3 4.92893 3 7.28595 3 12C3 16.714 3 19.0711 4.31802 20.5355Z",
    stroke: "#717784",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C7 7.53501 7 7.30252 7.05111 7.11177C7.18981 6.59413 7.59413 6.18981 8.11177 6.05111C8.30252 6 8.53501 6 9 6H15C15.465 6 15.6975 6 15.8882 6.05111C16.4059 6.18981 16.8102 6.59413 16.9489 7.11177C17 7.30252 17 7.53501 17 8C17 8.46499 17 8.69748 16.9489 8.88823C16.8102 9.40587 16.4059 9.81019 15.8882 9.94889C15.6975 10 15.465 10 15 10H9C8.53501 10 8.30252 10 8.11177 9.94889C7.59413 9.81019 7.18981 9.40587 7.05111 8.88823C7 8.69748 7 8.46499 7 8Z",
    stroke: "#717784",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.75C8.13807 12.75 8.25 12.8619 8.25 13C8.25 13.1381 8.13807 13.25 8 13.25C7.86193 13.25 7.75 13.1381 7.75 13C7.75 12.8619 7.86193 12.75 8 12.75Z",
    fill: "#717784",
    stroke: "#717784",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.75C8.13807 16.75 8.25 16.8619 8.25 17C8.25 17.1381 8.13807 17.25 8 17.25C7.86193 17.25 7.75 17.1381 7.75 17C7.75 16.8619 7.86193 16.75 8 16.75Z",
    fill: "#717784",
    stroke: "#717784",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75C12.1381 12.75 12.25 12.8619 12.25 13C12.25 13.1381 12.1381 13.25 12 13.25C11.8619 13.25 11.75 13.1381 11.75 13C11.75 12.8619 11.8619 12.75 12 12.75Z",
    fill: "#717784",
    stroke: "#717784",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.75C12.1381 16.75 12.25 16.8619 12.25 17C12.25 17.1381 12.1381 17.25 12 17.25C11.8619 17.25 11.75 17.1381 11.75 17C11.75 16.8619 11.8619 16.75 12 16.75Z",
    fill: "#717784",
    stroke: "#717784",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.75C16.1381 12.75 16.25 12.8619 16.25 13C16.25 13.1381 16.1381 13.25 16 13.25C15.8619 13.25 15.75 13.1381 15.75 13C15.75 12.8619 15.8619 12.75 16 12.75Z",
    fill: "#717784",
    stroke: "#717784",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.75C16.1381 16.75 16.25 16.8619 16.25 17C16.25 17.1381 16.1381 17.25 16 17.25C15.8619 17.25 15.75 17.1381 15.75 17C15.75 16.8619 15.8619 16.75 16 16.75Z",
    fill: "#717784",
    stroke: "#717784",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.fb53fdde1938811b354b8c5e99c1498c.svg";
export { ForwardRef as ReactComponent };